import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from "@reduxjs/toolkit";
import {
  createGlobalOffers,
  deleteGlobalOffers,
  getGlobalOffers,
  updateGlobalOfferMachines,
  updateGlobalOffers,
} from "data/server_apis/globalOffers";

const offerAdapter = createEntityAdapter({ selectId: (offer) => offer.id });

export const getGlobalOffersThunk = createAsyncThunk(
  "globalOffers/get",
  async ({ page, pageSize }, { rejectWithValue }) => {
    try {
      return (await getGlobalOffers(page, pageSize)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const createGlobalOffersThunk = createAsyncThunk(
  "globalOffers/create",
  async (data, { rejectWithValue }) => {
    try {
      return (await createGlobalOffers(data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const updateGlobalOffersThunk = createAsyncThunk(
  "globalOffer/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      return (await updateGlobalOffers(id, data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const updateGlobalOfferMachinesThunk = createAsyncThunk(
  "globalOffer/updateGlobalOfferMachines",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      return (await updateGlobalOfferMachines(id, data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const deleteGlobalOffersThunk = createAsyncThunk(
  "globalOffer/delete",
  async (id, { rejectWithValue }) => {
    try {
      return (await deleteGlobalOffers(id)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

const globalOffersSlice = createSlice({
  name: "globalOffers",
  initialState: offerAdapter.getInitialState({
    status: {},
    totalItems: 0,
  }),
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getGlobalOffersThunk.pending, (state, action) => {
        state.status = { loading: "get" };
      })
      .addCase(getGlobalOffersThunk.rejected, (state, action) => {
        state.status = { error: "get", errorMessage: action.payload?.message };
      })
      .addCase(getGlobalOffersThunk.fulfilled, (state, action) => {
        state.status = { success: "get" };
        // console.log("global offers get :", action.payload);

        offerAdapter.setAll(state, action.payload.results);
        state.totalItems = action.payload.total_items
      });

    builder
      .addCase(createGlobalOffersThunk.pending, (state, action) => {
        state.status = { loading: "create" };
      })
      .addCase(createGlobalOffersThunk.rejected, (state, action) => {
        state.status = {
          error: "create",
          errorMessage: action.payload?.message,
        };
      })
      .addCase(createGlobalOffersThunk.fulfilled, (state, action) => {
        state.status = { success: "create" };
        offerAdapter.addOne(state, action.payload);
      });

    builder
      .addCase(updateGlobalOffersThunk.pending, (state, action) => {
        state.status = { loading: "update", id: action.meta.arg.id };
      })
      .addCase(updateGlobalOffersThunk.rejected, (state, action) => {
        state.status = {
          error: "update",
          errorMessage: action.payload?.message,
          id: action.meta.arg.id,
        };
      })
      .addCase(updateGlobalOffersThunk.fulfilled, (state, action) => {
        state.status = { success: "update" };
        offerAdapter.updateOne(state, {
          id: action.meta.arg.id,
          changes: action.payload,
        });
      });

    builder
      .addCase(updateGlobalOfferMachinesThunk.pending, (state, action) => {
        state.status = { loading: "update", id: action.meta.arg.id };
      })
      .addCase(updateGlobalOfferMachinesThunk.rejected, (state, action) => {
        state.status = {
          error: "update",
          errorMessage: action.payload?.message,
          id: action.meta.arg.id,
        };
      })
      .addCase(updateGlobalOfferMachinesThunk.fulfilled, (state, action) => {
        state.status = { success: "update" };
        offerAdapter.updateOne(state, {
          id: action.meta.arg.id,
          changes: action.payload,
        });
      });

    builder
      .addCase(deleteGlobalOffersThunk.pending, (state, action) => {
        state.status = { loading: "delete", id: action.meta.arg.id };
      })
      .addCase(deleteGlobalOffersThunk.rejected, (state, action) => {
        state.status = {
          id: action.meta.arg.id,
          error: "delete",
          errorMessage: action.payload?.message,
        };
      })
      .addCase(deleteGlobalOffersThunk.fulfilled, (state, action) => {
        state.status = { success: "delete", id: action.meta.arg.id };
        offerAdapter.removeOne(state, action.meta.arg.id);
      });
  },
});

export const offerSelector = offerAdapter.getSelectors(
  (state) => state.globalOffers
);

export const {} = globalOffersSlice.actions;

export default globalOffersSlice.reducer;
